'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _CaretRightOutlined = _interopRequireDefault(require('./lib/icons/CaretRightOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _CaretRightOutlined;
exports.default = _default;
module.exports = _default;